/* RugLab — sepet kilometre taslari: ucretsiz kargo (500 TL) + hediye paspas (1400 TL).
 *
 * NEDEN AYRI DOSYA:
 *   Bu mantik daha once ruglab-studio.js icindeydi ve paralel oturumlar o dosyayi
 *   bastan yazdiginda 4 kez silindi (bkz. TODAY.md "cekismeli dosya"). Burasi
 *   bagimsiz calisir; ruglab-studio.js tamamen ezilse bile hediye akisi ayakta kalir.
 *
 * NASIL BAGLANIR:
 *   ruglab-studio.js'e HIC dokunmaz. window.fetch'i sarar; sepet degistiren
 *   cagrilari yakalar, hediyeyi normallestirir ve cagirana SON sepeti dondurur —
 *   boylece tema kendi cizimini zaten dogru veriyle yapar.
 */
(function () {
  "use strict";

  /* 2026-09-11: document.currentScript SADECE bu IIFE'nin senkron ilk calismasi
     sirasinda geçerli (event handler / fetch callback icinde null doner) --
     kendi klasor adresimizi HEMEN, en basta yakalamak zorundayiz. Liquid burada
     yok, .js dosyasi asset adresini boyle cikarir. */
  var VARLIK_TABAN = (function () {
    var s = document.currentScript;
    var src = s && s.src;
    if (!src) return null;
    return src.replace(/[^\/]*$/, ""); // dosya adi ("rl-cart-gift.js?v=...") atilir
  })();

  /* 2026-09-10: Turkiye ici kargo kosulsuz ucretsiz oldu; esik 0 yapildi ki
     'kargoya X kaldi' dali hic calismasin ve hediye cubugu devralsin.
     Kargo cubugu rl-header.liquid'den de kaldirildi. */
  var SHIP_ESIK = 0;
  var GIFT_ESIK = 140000;  // 1400 TL (kurus)
  var CART_YOLU = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_OKU  = /\/cart\.js(\?|$)/;
  var BEDEL_HANDLE = "kapida-odeme-bedeli";  // 2026-09-13: kapida odeme hizmet bedeli urunu

  /* hamFetch = script yuklenirken yakalanan ORIJINAL fetch. Kendi cagrilarimiz
     bunu kullandigi icin sarmalayiciya hic ugramiyor — ayrica "kilit" bayragina
     gerek yok. (Kilit vardi ve ZARARLIYDI: paralel hediye istegi kilidi acinca
     sarmalayici temanin istegini es geciyordu.) */
  var hamFetch = window.fetch && window.fetch.bind(window);
  var degisti = false;     // esitle() sepete gercekten dokundu mu (sunucu sayfasi tazelensin diye)
  var sonSepet = null;     // en son bilinen gercek sepet (aninda geri bildirim icin)


  /* ---------- TEK UYGULAMA NOKTASI ----------
     Panelin dogru gorunumu HER ZAMAN buradan cizilir. Onceki surumde "kendi
     cizimimiz" bayragi vardi ve GUVENILMEZDI: bayrak setTimeout ile temizleniyor,
     temanin cizimi tam o araliga denk gelince gozlemci atlaniyor ve panel yanlis
     kaliyordu (X ile silmede IKI cubuk birden goruldu, hediye satirinin kilidi
     kayboldu — Doruk, 2026-07-29).
     Yeni yapi: bayrak yok. Tum yazmalar KOSULLU (ayni degeri tekrar yazmiyoruz),
     bu yuzden ikinci gecis hic mutasyon uretmiyor ve gozlemci dongusu kendi
     kendine duruyor. Beklemede tahmin varsa tahmini, yoksa gercek sepeti cizeriz. */
  function etkinSepet() {
    if (bekleyen && Object.keys(bekleyen).length && sonSepet) return tahminiSepet();
    return sonSepet;
  }

  /* Bos sepet baglantisi tek bir lab'e (Garage) yolluyordu; musteriyi daralticiydi.
     Metin ruglab-studio.js icinde uretiliyor ve o dosya cekismeli (Codex de orada
     calisiyor) — bu yuzden cizimden SONRA burada duzeltiyoruz. */
  function bosSepetBaglantisi() {
    var a = document.querySelector(".rl-cartdrawer__empty a");
    if (!a) return;
    /* tum-urunler = gizli sistem urunlerini (hediye paspas, ozel olcu teknik urunu)
       disarida birakan akilli koleksiyon; /collections/all onlari da iceriyor. */
    if (a.getAttribute("href") !== "/collections/tum-urunler") a.setAttribute("href", "/collections/tum-urunler");
    if (a.textContent !== "Tüm ürünlere göz at") a.textContent = "Tüm ürünlere göz at";
  }

  function uygula() {
    bosSepetBaglantisi();
    var c = etkinSepet();
    if (!c || !c.items) return;
    ciz(c);
    satiriKilitle(c);
    bedelSatiriKilitle(c);
    satirlariCiz(c);
    if (giftVaryant()) {
      var hakEdildi = gercekUrunVarMi(c) && esikTutari(c) >= GIFT_ESIK;
      geciciHediyeSatiri(hakEdildi && !hediyeSatirlari(c).length);
    }
  }

  function kaydet(cart) {  // tek gercek-sepet girisi
    if (!cart || !cart.items) return cart;
    sonSepet = cart;
    /* KOSULSUZ yeniden ciz. Onceki surumde "bekleyen varken boyama" korumasi
       vardi ve TAKILMAYA yol aciyordu: gonderim yarida kalirsa ekran tahmini
       degerde asili kaliyor, sunucu verisi geldiginde bile duzelmiyordu
       (olcum: panel 4, sunucu 2 — Doruk'un gordugu "buglu" hissin kaynagi).
       Guvenli, cunku bekleyen hedefler MUTLAK adet tutuyor: sunucu uygulamis
       olsa bile ayni hedefi tekrar yazmak sonucu degistirmiyor. */
    uygula();
    ozelDurumunuGetir(); // 2026-09-13: odeme secicisinin ozel/bedel durumunu tazele (asenkron)
    return cart;
  }

  /* Tema drawer'i yeniden cizince kendi renderShipProgress'ini uyguluyor ve bizim
     cubugumuzu eziyor. setTimeout ile yarismak GUVENILMEZ — sentetik Response'un
     json() cozulme ani degisken, bazen tema bizden sonra ciziyor. Cozum: cizimi
     gozlemleyip ardindan duzeltmek. Yaris yok, sira garantili. */
  function gozlemeBasla() {
    var govde = document.querySelector("[data-cart-drawer-items]");
    if (!govde || !window.MutationObserver) return;
    var bekletme = null;
    new MutationObserver(function () {
      if (bekletme) window.clearTimeout(bekletme);
      bekletme = window.setTimeout(uygula, 30);   // kosullu yazma sayesinde dongu kendi kendine biter
    }).observe(govde, { childList: true, subtree: true });
  }

  function money(k) {
    return (Number(k || 0) / 100).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " TL";
  }
  function shipKutu() { return document.querySelector("[data-cart-ship]"); }
  function giftKutu() { return document.querySelector("[data-cart-gift]"); }
  function giftVaryant() {
    var el = giftKutu();
    return el ? (parseInt(el.getAttribute("data-gift-variant"), 10) || 0) : 0;
  }

  /* Cart Transform: /cart.js ozel olcu satirinda TEKNIK fiyati dondurur (10 TL).
     Gercek fiyat _rl_custom_price ozelliginde saklaniyor — drawer da bunu kullaniyor.
     Esigi teknik fiyatla hesaplasaydik 2.000 TL'lik sepet 20 TL gorunurdu. */
  function satirTutari(item) {
    var props = (item && item.properties) || {};
    var ct = props["_rl_custom_price"];
    if (ct && /^\d+$/.test(String(ct))) return parseInt(ct, 10) * (item.quantity || 1);
    return Number(item.final_line_price || 0);
  }

  function hediyeSatirlari(cart) {
    var vid = giftVaryant();
    if (!vid) return [];
    return (cart && cart.items || []).filter(function (i) { return i.variant_id === vid; });
  }
  /* Hediye satiri esige SAYILMAZ — yoksa hediye kendi kendini finanse eder.
     2026-09-13: bedel satiri da SAYILMAZ -- bedel yuzunden hediye otomatik eklenmemeli. */
  function esikTutari(cart) {
    var vid = giftVaryant(), t = 0;
    (cart && cart.items || []).forEach(function (it) {
      if (vid && it.variant_id === vid) return;
      if (it.handle === BEDEL_HANDLE) return;
      t += satirTutari(it);
    });
    return t;
  }
  function gercekUrunVarMi(cart) {
    var vid = giftVaryant();
    return (cart && cart.items || []).some(function (it) { return !vid || it.variant_id !== vid; });
  }

  /* ---------- cizim: ayni anda TEK cubuk (siradaki hedef) ---------- */
  function yaz(kutu, tamam, oran, mesaj) {
    if (!kutu) return;
    if (kutu.hidden) kutu.hidden = false;
    kutu.classList.toggle("is-done", !!tamam);
    if (!kutu) return;   /* cubuk DOM'dan kaldirilmis olabilir */
    var msg = kutu.querySelector("[data-cart-ship-msg], [data-cart-gift-msg]");
    var fill = kutu.querySelector("[data-cart-ship-fill], [data-cart-gift-fill]");
    if (msg && msg.textContent !== mesaj) msg.textContent = mesaj;
    var g = Math.min(100, Math.max(0, oran * 100)).toFixed(1) + "%";
    if (fill && fill.style.width !== g) fill.style.width = g;
  }

  function ciz(cart) {
    var ship = shipKutu(), gift = giftKutu();
    var bos = !cart || !cart.items || !cart.items.length;
    if (bos) {
      if (ship && !ship.hidden) ship.hidden = true;
      if (gift && !gift.hidden) gift.hidden = true;
      return;
    }
    var tutar = esikTutari(cart);
    if (tutar < SHIP_ESIK) {                       // hedef 1: kargo
      if (gift && !gift.hidden) gift.hidden = true;
      yaz(ship, false, tutar / SHIP_ESIK, "Ücretsiz kargoya " + money(SHIP_ESIK - tutar) + " kaldı");
    } else if (gift && tutar < GIFT_ESIK) {        // hedef 2: hediye
      if (ship && !ship.hidden) ship.hidden = true;
      yaz(gift, false, tutar / GIFT_ESIK, "Hediye paspasına " + money(GIFT_ESIK - tutar) + " kaldı 🎁");
    } else {
      // Ikisi de kazanildi. SON dolan cubuk (hediye) dolu + yesil KALIR.
      // Onceki surum hediye cubugunu gizleyip mesaji kargo cubuguna tasiyordu;
      // musteri dolan cubugun kaybolmasini "bozuldu" diye okuyor (Doruk, 2026-07-29).
      if (gift) {
        if (ship && !ship.hidden) ship.hidden = true;
        yaz(gift, true, 1, "Ücretsiz kargo + hediye paspas kazandın ✓🎁");
      } else {
        yaz(ship, true, 1, "Ücretsiz kargo kazandın ✓");
      }
    }
  }

  /* ---------- hediye satirini musteri duzenleyemesin ----------
     Adet artirilinca fazlasi PARALI donuyordu (Shopify indirimi yalniz 1 adede
     uygulaniyor) — hos olmayan bir deneyim. Cozum iki katmanli: adet/kaldir
     kontrollerini gizle (asagisi) + sepette adedi 1'e sabitle (esitle). */
  function stilEkle() {
    if (document.getElementById("rl-gift-stil")) return;
    var s = document.createElement("style");
    s.id = "rl-gift-stil";
    s.textContent =
      ".rl-cartdrawer__item.rl-gift-line .rl-cartdrawer__qty," +
      ".rl-cartdrawer__item.rl-gift-line [data-cart-remove]," +
      ".rl-cartdrawer__item.rl-bedel-line .rl-cartdrawer__qty," +
      ".rl-cartdrawer__item.rl-bedel-line [data-cart-remove]{display:none!important}" +
      /* 2026-09-11: .rl-cartdrawer__info bir grid hucresi; grid item varsayilan olarak
         justify-self:stretch aldigindan rozet TUM genisligi kapliyordu. */
      ".rl-gift-rozet{display:inline-flex;justify-self:start;width:auto;margin-top:4px;padding:2px 9px;border-radius:999px;" +
      "border:1px solid color-mix(in srgb,var(--rl-accent) 45%,transparent);" +
      "color:var(--rl-accent);font-size:11px;font-weight:800;letter-spacing:.04em;white-space:nowrap}" +
      /* 2026-09-11: satir kucuk resmi -- ayni sicak gri zemin, kucuk ic bosluk. rl-gift-line
         hem cekmece satirina (JS ile) hem /cart satirina (Liquid'deki is_gift ile) ekleniyor. */
      ".rl-gift-line .rl-cartdrawer__media img,.rl-gift-line .rl-citem__media img{" +
      "background:linear-gradient(160deg,#2b2723,#1c1a17);padding:6px;border-radius:10px;" +
      "box-sizing:border-box;object-fit:contain}";
    document.head.appendChild(s);
  }

  /* ---------- 2026-09-11: HEDIYE TASARIMI SECIMI (Doruk: "musteri gercek paspaslar arasindan secsin") ----------
     Tek hediye varyanti kalir; secim hediye satirina "Hediye tasarımı" ozelligi olarak yazilir
     (/cart/change.js). Cart Transform (v9) bu ozelligi hediye paketine tasir -> siparise duser.
     `kod` alani uretimin kaynak PRINT dosyasini bulmasi icin tutulur (asset adinda da var,
     yorum satirinda kaynak dosya adi acikca duruyor). Ilk sira = varsayilan secim. */
  var HEDIYE_OZELLIK = "Hediye tasarımı";
  var HEDIYE_TASARIMLARI = [
    // art lab/hali/rl-art-242-gold-medallion-paspas-PRINT.png
    { ad: "Altın Madalyon", kod: "art-242", gorsel: "rl-hediye-art-242.webp" },
    // art lab/hali/rl-art-222-gold-spiral-paspas-PRINT.png
    { ad: "Altın Spiral", kod: "art-222", gorsel: "rl-hediye-art-222.webp" },
    // art lab/hali/rl-art-91-klimt-tree-paspas-PRINT.png
    { ad: "Klimt Ağacı", kod: "art-91", gorsel: "rl-hediye-art-91.webp" },
    // garage lab/hali/rl-garage-81-jdm-gauges-paspas-PRINT.png
    { ad: "JDM Göstergeler", kod: "garage-81", gorsel: "rl-hediye-garage-81.webp" },
    // garage lab/hali/rl-garage-84-boost-gauge-paspas-PRINT.png
    { ad: "Boost Göstergesi", kod: "garage-84", gorsel: "rl-hediye-garage-84.webp" },
    // arcade lab/hali/rl-arcade-91-coin-slot-paspas-PRINT.png
    { ad: "Jeton Yuvası", kod: "arcade-91", gorsel: "rl-hediye-arcade-91.webp" }
  ];

  function varsayilanSecim() {
    var o = {};
    o[HEDIYE_OZELLIK] = HEDIYE_TASARIMLARI[0].ad;
    return o;
  }
  function tasarimBul(ad) {
    var bulunan = null;
    HEDIYE_TASARIMLARI.forEach(function (t) { if (t.ad === ad) bulunan = t; });
    return bulunan;
  }
  function gorselAdresi(tasarim) {
    if (!VARLIK_TABAN || !tasarim || !tasarim.gorsel) return null;
    return VARLIK_TABAN + tasarim.gorsel;
  }
  // Secim penceresindeki BUYUK kart gorseli (kucuk resimden ayri dosya, 2:3).
  function gorselAdresiBuyuk(tasarim) {
    if (!VARLIK_TABAN || !tasarim || !tasarim.kod) return null;
    return VARLIK_TABAN + "rl-hediye-" + tasarim.kod + "-buyuk.webp";
  }
  function tasarimBulKod(kod) {
    var bulunan = null;
    HEDIYE_TASARIMLARI.forEach(function (t) { if (t.kod === kod) bulunan = t; });
    return bulunan;
  }

  /* Eski test sepetlerinde gecerli listede olmayan bir deger kalmis olabilir (ornek: "Paspas 2").
     Anahtar basina TEK deneme bayragiyla varsayilana cekilir -- sonsuz donguye girmez. */
  var duzeltmeDenendi = {};
  function varsayilanaCek(anahtar) {
    if (!anahtar || duzeltmeDenendi[anahtar]) return;
    duzeltmeDenendi[anahtar] = 1;
    window.fetch("/cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: anahtar, quantity: 1, properties: varsayilanSecim() })
    }).catch(function () {});
  }

  /* Hediye satirinin/kutusunun kendi kucuk resmini secilen tasarima gore guncelle.
     srcset varsa kaldirilir (eski surumden kalabilir); adres zaten aynıysa dokunulmaz. */
  function satirGorseliGuncelle(satirEl, secili) {
    if (!satirEl) return;
    var img = satirEl.querySelector(".rl-cartdrawer__media img, .rl-citem__media img");
    if (!img) return;
    var tasarim = tasarimBul(secili) || HEDIYE_TASARIMLARI[0];
    var url = gorselAdresi(tasarim);
    if (!url) return;
    if (img.hasAttribute("srcset")) img.removeAttribute("srcset");
    if (img.getAttribute("src") !== url) img.src = url;
  }

  /* ---------- 2026-09-11: PAYLASILAN HEDIYE SECIM PENCERESI ----------
     Tek DOM ornegi var, body'ye eklenir, tum satirlardaki "Hediyeni seç" dugmeleri aynisini acar.
     Mobilde alttan acilan sayfa, masaustunde ortada pencere (medya sorgusuyla ayni CSS). Karta
     dokunmak SADECE yerel secimi degistirir; sunucuya yazma yalnizca alt cubuktaki "Bu hediyeyi
     seç" ile olur (mevcut deger ise ag istegi atmadan kapanir). */
  var modalEl, modalPanel, modalIzgara, modalHataEl, modalOnaylaBtn;
  var modalAnahtar = null;        // hangi sepet satiri icin acildi
  var modalSecim = null;          // penceredeki GECICI secim (kaydedilmedi)
  var modalOrijinalSecim = null;  // acilista gelen deger -- degismediyse ag istegi atma
  var modalSonra = null;          // basari sonrasi cagrilacak (RugLabCart.open ya da reload)
  var modalTetikleyici = null;    // kapaninca odagin geri donecegi dugme
  var modalGorselYuklendi = false; // buyuk kart gorselleri yalniz ILK acilista atanir
  var modalGonderimde = false;

  function modalStil() {
    if (document.getElementById("rl-gift-modal-stil")) return;
    var st = document.createElement("style");
    st.id = "rl-gift-modal-stil";
    st.textContent =
      ".rl-gift-modal{position:fixed;inset:0;z-index:99999;display:flex;align-items:flex-end;justify-content:center}" +
      ".rl-gift-modal[hidden]{display:none}" +
      ".rl-gift-modal__backdrop{position:absolute;inset:0;background:rgba(10,8,4,.6);" +
        "backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);opacity:0;transition:opacity .18s ease}" +
      ".rl-gift-modal.is-acik .rl-gift-modal__backdrop{opacity:1}" +
      ".rl-gift-modal__panel{position:relative;width:100%;max-height:88vh;background:#17140d;color:#f3ead9;" +
        "border-radius:18px 18px 0 0;display:flex;flex-direction:column;overflow:hidden;" +
        "transform:translateY(100%);transition:transform .18s ease;outline:none}" +
      ".rl-gift-modal.is-acik .rl-gift-modal__panel{transform:translateY(0)}" +
      "@media(min-width:600px){.rl-gift-modal{align-items:center}" +
        ".rl-gift-modal__panel{width:92vw;max-width:720px;max-height:80vh;border-radius:18px;" +
        "transform:translateY(12px) scale(.98)}" +
        ".rl-gift-modal.is-acik .rl-gift-modal__panel{transform:translateY(0) scale(1)}}" +
      "@media(prefers-reduced-motion:reduce){.rl-gift-modal__backdrop,.rl-gift-modal__panel{transition:none}}" +
      ".rl-gift-modal__tutamak{width:36px;height:4px;border-radius:999px;background:rgba(255,255,255,.25);margin:10px auto 0;flex:0 0 auto}" +
      "@media(min-width:600px){.rl-gift-modal__tutamak{display:none}}" +
      ".rl-gift-modal__head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:14px 18px 6px;flex:0 0 auto}" +
      ".rl-gift-modal__baslik{margin:0;font-size:16px;font-weight:800}" +
      ".rl-gift-modal__alt{margin:2px 0 0;font-size:12px;opacity:.7}" +
      ".rl-gift-modal__kapat{width:28px;height:28px;border-radius:999px;border:0;background:rgba(255,255,255,.08);" +
        "color:inherit;font-size:16px;line-height:1;cursor:pointer;flex:0 0 auto}" +
      /* 2026-09-11: izgara ayni zamanda kaydirma alani (overflow-y:auto) oldugundan grid'in
         varsayilan auto-satir boyu, tasan kartlari SIGDIRMAK icin 173px'e kadar eziyordu (kart
         gorseli 160x239 kirpiliyor, ad hic gorunmuyordu). align-content:start + grid-auto-rows:
         max-content satirlari icerik boyunda tutar; tasma artik izgaranin KENDI scrollY'sinde olur. */
      ".rl-gift-modal__izgara{display:grid;grid-template-columns:repeat(2,1fr);gap:12px;padding:12px 18px 16px;" +
        "overflow-y:auto;flex:1 1 auto;min-height:0;align-content:start;grid-auto-rows:max-content}" +
      "@media(min-width:600px){.rl-gift-modal__izgara{grid-template-columns:repeat(3,1fr);gap:16px;padding:16px 20px}}" +
      ".rl-gift-modal__kart{position:relative;border:2px solid transparent;border-radius:14px;padding:0;" +
        "background:rgba(255,255,255,.03);cursor:pointer;text-align:left;overflow:hidden;min-height:min-content;" +
        "transition:transform .12s ease,border-color .12s ease;color:inherit;font:inherit}" +
      /* 2026-09-11: paspaslarin kaucuk kenari koyu (#151515-#1f1f1f) -- koyu arayuzde kenar
         goze hic carpmiyordu. Sicak gri zemin + 10px ic bosluk kenari secik hale getirir. */
      ".rl-gift-modal__kart-gorsel{aspect-ratio:2/3;padding:10px;border-radius:10px;box-sizing:border-box;" +
        "background:linear-gradient(160deg,#2b2723,#1c1a17)}" +
      ".rl-gift-modal__kart-gorsel img{width:100%;height:100%;object-fit:contain;display:block}" +
      ".rl-gift-modal__kart-alt{padding:8px 10px 10px}" +
      ".rl-gift-modal__kart-ad{display:block;font-size:12.5px;font-weight:700}" +
      ".rl-gift-modal__kart.is-secili{border-color:var(--rl-accent,#d6b25e)}" +
      "@media(hover:hover){.rl-gift-modal__kart:hover{transform:translateY(-2px)}}" +
      ".rl-gift-modal__check{position:absolute;top:6px;right:6px;width:20px;height:20px;border-radius:999px;" +
        "background:var(--rl-accent,#d6b25e);color:#17120a;font-size:12px;font-weight:900;" +
        "display:none;align-items:center;justify-content:center}" +
      ".rl-gift-modal__kart.is-secili .rl-gift-modal__check{display:flex}" +
      ".rl-gift-modal__alt-cubuk{padding:12px 18px 16px;border-top:1px solid rgba(255,255,255,.08);display:grid;gap:8px;flex:0 0 auto}" +
      ".rl-gift-modal__hata{margin:0;font-size:12px;color:#ffb0b0}" +
      ".rl-gift-modal__hata[hidden]{display:none}" +
      ".rl-gift-modal__onayla{padding:12px 16px;border-radius:12px;border:0;background:var(--rl-accent,#d6b25e);" +
        "color:#17120a;font-weight:800;font-size:14px;cursor:pointer}" +
      ".rl-gift-modal__onayla:disabled{opacity:.6;cursor:wait}";
    document.head.appendChild(st);
  }

  function modalHataMesaji(msg) {
    if (!modalHataEl) return;
    modalHataEl.textContent = msg || "";
    modalHataEl.hidden = !msg;
  }

  function modalSecimYap(ad) {
    modalSecim = ad;
    Array.prototype.slice.call(modalIzgara.querySelectorAll(".rl-gift-modal__kart")).forEach(function (kart) {
      var t = tasarimBulKod(kart.getAttribute("data-kod"));
      var secildi = !!(t && t.ad === ad);
      kart.classList.toggle("is-secili", secildi);
      kart.setAttribute("aria-pressed", secildi ? "true" : "false");
    });
    modalHataMesaji("");
  }

  function modalGorselleriYukle() {
    if (modalGorselYuklendi) return;
    modalGorselYuklendi = true;
    Array.prototype.slice.call(modalIzgara.querySelectorAll(".rl-gift-modal__kart")).forEach(function (kart) {
      var t = tasarimBulKod(kart.getAttribute("data-kod"));
      var img = kart.querySelector("img");
      var url = t && gorselAdresiBuyuk(t);
      if (img && url) img.src = url;
    });
  }

  function modalOlustur() {
    if (modalEl) return;
    modalStil();
    modalEl = document.createElement("div");
    modalEl.className = "rl-gift-modal";
    modalEl.hidden = true;
    modalEl.innerHTML =
      '<div class="rl-gift-modal__backdrop" data-rl-gift-modal-backdrop></div>' +
      '<div class="rl-gift-modal__panel" role="dialog" aria-modal="true" aria-labelledby="rl-gift-modal-baslik" tabindex="-1">' +
        '<div class="rl-gift-modal__tutamak"></div>' +
        '<div class="rl-gift-modal__head">' +
          '<div>' +
            '<h2 class="rl-gift-modal__baslik" id="rl-gift-modal-baslik">Hediye paspasını seç</h2>' +
            '<p class="rl-gift-modal__alt">40×60 cm · sepetine ücretsiz eklenir</p>' +
          '</div>' +
          '<button type="button" class="rl-gift-modal__kapat" data-rl-gift-modal-kapat aria-label="Kapat">&times;</button>' +
        '</div>' +
        '<div class="rl-gift-modal__izgara" data-rl-gift-modal-izgara></div>' +
        '<div class="rl-gift-modal__alt-cubuk">' +
          '<p class="rl-gift-modal__hata" data-rl-gift-modal-hata hidden></p>' +
          '<button type="button" class="rl-gift-modal__onayla" data-rl-gift-modal-onayla>Bu hediyeyi seç</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modalEl);

    modalPanel = modalEl.querySelector(".rl-gift-modal__panel");
    modalIzgara = modalEl.querySelector("[data-rl-gift-modal-izgara]");
    modalHataEl = modalEl.querySelector("[data-rl-gift-modal-hata]");
    modalOnaylaBtn = modalEl.querySelector("[data-rl-gift-modal-onayla]");

    HEDIYE_TASARIMLARI.forEach(function (t) {
      var kart = document.createElement("button");
      kart.type = "button";
      kart.className = "rl-gift-modal__kart";
      kart.setAttribute("data-kod", t.kod);
      kart.setAttribute("aria-pressed", "false");

      var gorselKutu = document.createElement("div");
      gorselKutu.className = "rl-gift-modal__kart-gorsel";
      var img = document.createElement("img");
      img.alt = t.ad;
      img.decoding = "async";
      gorselKutu.appendChild(img);
      kart.appendChild(gorselKutu);

      var check = document.createElement("span");
      check.className = "rl-gift-modal__check";
      check.textContent = "✓";
      kart.appendChild(check);

      var altKutu = document.createElement("div");
      altKutu.className = "rl-gift-modal__kart-alt";
      var adSpan = document.createElement("span");
      adSpan.className = "rl-gift-modal__kart-ad";
      adSpan.textContent = t.ad;
      altKutu.appendChild(adSpan);
      kart.appendChild(altKutu);

      kart.addEventListener("click", function () { modalSecimYap(t.ad); });
      modalIzgara.appendChild(kart);
    });

    modalEl.querySelector("[data-rl-gift-modal-backdrop]").addEventListener("click", modalKapat);
    modalEl.querySelector("[data-rl-gift-modal-kapat]").addEventListener("click", modalKapat);
    modalOnaylaBtn.addEventListener("click", modalOnayla);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modalEl && !modalEl.hidden) modalKapat();
    });
  }

  function modalAc(anahtar, secili, sonra, tetikleyici) {
    if (!anahtar) return;
    modalOlustur();
    modalAnahtar = anahtar;
    modalOrijinalSecim = secili;
    modalSonra = sonra;
    modalTetikleyici = tetikleyici || null;
    modalSecimYap(tasarimBul(secili) ? secili : HEDIYE_TASARIMLARI[0].ad);
    modalOnaylaBtn.disabled = false;
    modalOnaylaBtn.textContent = "Bu hediyeyi seç";
    modalGorselleriYukle();

    modalEl.hidden = false;
    document.body.style.overflow = "hidden"; // acikken sayfa kaydirma kilidi
    // Ayni frame'de sinif eklenirse tarayici transition'i atlayabilir -- bir sonraki frame'e birak.
    window.requestAnimationFrame(function () { modalEl.classList.add("is-acik"); });

    var seciliKart = modalIzgara.querySelector(".rl-gift-modal__kart.is-secili");
    if (seciliKart && seciliKart.focus) seciliKart.focus();
    else if (modalPanel && modalPanel.focus) modalPanel.focus();
  }

  function modalKapat() {
    if (!modalEl || modalEl.hidden || modalGonderimde) return; // kaydederken kapanmasin
    modalEl.classList.remove("is-acik");
    document.body.style.overflow = "";
    var azaltilmis = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (azaltilmis) modalEl.hidden = true;
    else window.setTimeout(function () { if (modalEl) modalEl.hidden = true; }, 180);
    if (modalTetikleyici && modalTetikleyici.focus) modalTetikleyici.focus();
  }

  function modalOnayla() {
    if (!modalAnahtar || modalGonderimde) return;
    if (!modalSecim || modalSecim === modalOrijinalSecim) { modalKapat(); return; }
    modalGonderimde = true;
    modalOnaylaBtn.disabled = true;
    modalOnaylaBtn.textContent = "Kaydediliyor…";
    modalHataMesaji("");
    var ozellik = {};
    ozellik[HEDIYE_OZELLIK] = modalSecim;
    window.fetch("/cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: modalAnahtar, quantity: 1, properties: ozellik })
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        modalGonderimde = false;
        var sonra = modalSonra;
        modalKapat();
        if (sonra) sonra();
      })
      .catch(function () {
        modalGonderimde = false;
        modalOnaylaBtn.disabled = false;
        modalOnaylaBtn.textContent = "Bu hediyeyi seç";
        modalHataMesaji("Kaydedilemedi, tekrar dene");
      });
  }

  /* 2026-09-11: Doruk elestirisi ("kullanimi da gorseli de hoslanmadim") sonrasi yeniden tasarim --
     satirdaki 6'li kucuk resim seridi (48x72, sikisik, tasma) TAMAMEN kaldirildi. Satirda artik
     yalniz: satir resmi (mevcut takas, degismedi), mevcut ozellik satiri ("Hediye tasarımı: X" --
     bunu BU dosya YAZMAZ, tema/ruglab-cart.liquid zaten cart property olarak basiyor), ve tek bir
     "Hediyeni seç" dugmesi. Dugme yukaridaki paylasilan modal/bottom-sheet'i acar (modalAc). */
  function seciciStil() {
    if (document.getElementById("rl-gift-secim-stil")) return;
    var st = document.createElement("style");
    st.id = "rl-gift-secim-stil";
    st.textContent =
      ".rl-gift-secim{display:flex;flex-direction:column;gap:4px;margin-top:8px;min-width:0;max-width:100%}" +
      ".rl-gift-secim__ac{align-self:flex-start;display:inline-flex;align-items:center;gap:6px;" +
        "padding:8px 14px;border-radius:999px;border:1px solid var(--rl-accent,#d6b25e);" +
        "background:transparent;color:inherit;font:inherit;font-size:12.5px;font-weight:700;cursor:pointer;" +
        "min-width:0;max-width:100%}" +
      ".rl-gift-secim__ac:disabled{opacity:.5;cursor:wait}" +
      ".rl-gift-secim__alt{margin:0;font-size:11px;color:var(--rl-muted,#9a9184)}";
    document.head.appendChild(st);
  }

  /* 2026-09-11: pencere ilk acilista buyuk gorselleri o an cekiyordu -- gorunur "sonradan belirme"
     yaratiyordu. Hediye dugmesi sayfada (cekmece ya da /cart) ilk cizildiginde 6 buyuk gorseli
     new Image() ile ONDEN cek; sayfa basina TEK sefer (bayrak). Referanslar globalde tutulur ki
     GC'ye gitmesin -- gitmis olsa bile tarayici HTTP onbellegi zaten calisirdi, ama emin olalim. */
  var onYuklenenGorseller = [];
  var onYuklemeTetiklendi = false;
  function buyukGorselleriOnYukle() {
    if (onYuklemeTetiklendi) return;
    onYuklemeTetiklendi = true;
    HEDIYE_TASARIMLARI.forEach(function (t) {
      var url = gorselAdresiBuyuk(t);
      if (!url) return;
      var img = new Image();
      img.decoding = "async";
      img.src = url;
      onYuklenenGorseller.push(img);
    });
  }

  // Buton icerigi secime gore DEGISMEZ (isim artik satirda gosterilmiyor) -- bir kez cizilir,
  // sonraki cagrilar sadece data-* ozniteliklerini guncelller. DOM'a tekrar dokunmaz ->
  // MutationObserver dongu korumasi burada da gecerli.
  function dugmeCiz(kutu, anahtar, secili, sonra) {
    if (!kutu || !anahtar) return;
    seciciStil();
    stilEkle(); // 2026-09-11: /cart sayfasinda satiriKilitle CALISMAZ -- satir-resmi zemin CSS'i (.rl-gift-line) burada garanti girsin
    buyukGorselleriOnYukle();
    kutu.setAttribute("data-secili", secili || "");
    kutu.setAttribute("data-key", anahtar);
    if (kutu.getAttribute("data-cizildi") === "1") return;
    kutu.setAttribute("data-cizildi", "1");
    kutu.innerHTML = "";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "rl-gift-secim__ac";
    btn.textContent = "🎁 Hediyeni seç";
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      modalAc(kutu.getAttribute("data-key"), kutu.getAttribute("data-secili"), sonra, btn);
    });
    kutu.appendChild(btn);

    var alt = document.createElement("p");
    alt.className = "rl-gift-secim__alt";
    alt.textContent = HEDIYE_TASARIMLARI.length + " tasarım arasından";
    kutu.appendChild(alt);
  }

  /* Sepet sayfasi (/cart): Liquid bos kutuyu anahtar + mevcut secimle basar; dugmeyi burada ciz. */
  function sayfaSecicileri() {
    Array.prototype.slice.call(document.querySelectorAll("[data-rl-gift-secim][data-sayfa]")).forEach(function (k) {
      var anahtar = k.getAttribute("data-key");
      var secili = k.getAttribute("data-secili") || "";
      if (!tasarimBul(secili)) varsayilanaCek(anahtar);
      dugmeCiz(k, anahtar, secili, function () { window.location.reload(); });
      satirGorseliGuncelle(k.closest(".rl-citem"), secili);
    });
  }

  function satiriKilitle(cart) {
    var vid = giftVaryant();
    if (!vid) return;
    stilEkle();
    var anahtarlar = {};
    hediyeSatirlari(cart).forEach(function (i) { anahtarlar[i.key] = 1; });
    Array.prototype.slice.call(document.querySelectorAll(".rl-cartdrawer__item")).forEach(function (satir) {
      var k = satir.querySelector("[data-key]");
      var hediyeMi = !!(k && anahtarlar[k.getAttribute("data-key")]);
      satir.classList.toggle("rl-gift-line", hediyeMi);
      if (hediyeMi && !satir.querySelector(".rl-gift-rozet")) {
        var b = document.createElement("span");
        b.className = "rl-gift-rozet";
        b.textContent = "Hediyen 🎁";
        (satir.querySelector(".rl-cartdrawer__info") || satir).appendChild(b);
      }
      /* Cekmecede hediye satirinin altina tasarim secici (anahtar/secim degistiyse yeniden ciz;
         ayni kalinca DOM'a dokunma -> MutationObserver dongusu olmaz). */
      if (hediyeMi) {
        var anahtar = k.getAttribute("data-key");
        var hs = hediyeSatirlari(cart).filter(function (i) { return i.key === anahtar; })[0];
        var secili = (hs && hs.properties && hs.properties[HEDIYE_OZELLIK]) || "";
        if (!tasarimBul(secili)) varsayilanaCek(anahtar);
        satirGorseliGuncelle(satir, secili);
        var kutu = satir.querySelector("[data-rl-gift-secim]");
        if (!kutu) {
          kutu = document.createElement("div");
          kutu.className = "rl-gift-secim";
          kutu.setAttribute("data-rl-gift-secim", "");
          (satir.querySelector(".rl-cartdrawer__info") || satir).appendChild(kutu);
        }
        dugmeCiz(kutu, anahtar, secili, function () {
          if (window.RugLabCart && window.RugLabCart.open) window.RugLabCart.open();
        });
      }
    });
  }

  /* 2026-09-13: bedel satirinin adet/kaldir kontrollerini gizle -- AYNI CSS-sinifi-etiketleme
     yontemi (gift satirinda kanitlanmis): ruglab-studio.js'in HTML uretimine hic dokunmadan,
     ciziminden SONRA satiri isaretleyip stilEkle()'deki kural gizliyor. satiriKilitle()'dan
     BAGIMSIZ -- hediye varyanti olmasa da (giftVaryant()=0 olsa da) calismali. */
  function bedelSatiriKilitle(cart) {
    stilEkle();
    var anahtarlar = {};
    bedelSatirlari(cart).forEach(function (i) { anahtarlar[i.key] = 1; });
    Array.prototype.slice.call(document.querySelectorAll(".rl-cartdrawer__item")).forEach(function (satir) {
      var k = satir.querySelector("[data-key]");
      var bedelMi = !!(k && anahtarlar[k.getAttribute("data-key")]);
      satir.classList.toggle("rl-bedel-line", bedelMi);
    });
  }

  /* ---------- sepeti hediye kurallarina gore normallestir ----------
     Tek dogru durum: hak edildiyse TAM 1 adet TEK hediye satiri, yoksa hic.
     Her turda tek islem yapip sepeti yeniden okur (fazla satir + adet>1 hallolur). */
  function cartJson(yol, govde) {
    return hamFetch(yol, {
      method: govde ? "POST" : "GET",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: govde ? JSON.stringify(govde) : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function esitle(cart, tur) {
    tur = tur || 0;
    var vid = giftVaryant();
    if (!vid || !cart || tur > 3) return Promise.resolve(cart);

    var hediyeler = hediyeSatirlari(cart);
    var hakEdildi = gercekUrunVarMi(cart) && esikTutari(cart) >= GIFT_ESIK;
    var islem = null;

    if (!hakEdildi && hediyeler.length) islem = { id: hediyeler[0].key, quantity: 0 };
    else if (hakEdildi && !hediyeler.length) islem = { ekle: true };
    else if (hakEdildi && hediyeler.length > 1) islem = { id: hediyeler[1].key, quantity: 0 };
    else if (hakEdildi && hediyeler[0].quantity !== 1) islem = { id: hediyeler[0].key, quantity: 1 };

    if (!islem) return Promise.resolve(cart);
    degisti = true;
    // /cart/change.js TAM SEPETI dondurur -> ek /cart.js istegi GEREKMEZ.
    // Sadece /cart/add.js eklenen satiri dondurdugu icin onun ardindan sepet okunur.
    var p = islem.ekle
      ? cartJson("/cart/add.js", { id: vid, quantity: 1, properties: varsayilanSecim() }).then(function () { return cartJson("/cart.js"); })
      : cartJson("/cart/change.js", islem);
    return p.then(function (yeni) { return yeni ? esitle(yeni, tur + 1) : cart; });
  }

  /* ---------- 2026-09-13: KAPIDA ODEME HIZMET BEDELI ----------
     Bedel satiri handle'indan taninir (cart.js her satirda urun handle'ini dondurur -- varyant
     id'sini ONCEDEN bilmemize gerek yok). Iki sync kural burada: bedelden baska urun kalmazsa
     bedel kendiliginden kalkar (kural 5). "Kisiye ozel sepette bedel kalirsa kaldir" (kural 2)
     TAG/METAFIELD gerektirdigi icin ASENKRON -- asagidaki ozelDurumunuGetir()'de. */
  function bedelSatirlari(cart) {
    return (cart && cart.items || []).filter(function (it) { return it.handle === BEDEL_HANDLE; });
  }
  function gercekUrunVarMiBedelHaric(cart) {
    var vid = giftVaryant();
    return (cart && cart.items || []).some(function (it) {
      if (vid && it.variant_id === vid) return false;
      if (it.handle === BEDEL_HANDLE) return false;
      return true;
    });
  }
  // 2026-09-19: gift esitle()'daki gibi TEK dogru durum: gercek urun yoksa bedel HIC olmamali;
  // varsa TAM 1 adet TEK bedel satiri olmali. Her turda tek islem yapip sepeti yeniden okur --
  // hamFetch/cartJson kullanildigi icin fetch sarmalayicidan gecmez, dongu tur>3'te kesin biter.
  function bedelEsitle(cart, tur) {
    tur = tur || 0;
    if (!cart || tur > 3) return Promise.resolve(cart);
    var bedelSatirlar = bedelSatirlari(cart);
    if (!bedelSatirlar.length) return Promise.resolve(cart);

    var islem = null;
    if (!gercekUrunVarMiBedelHaric(cart)) {
      islem = { id: bedelSatirlar[0].key, quantity: 0 };
    } else if (bedelSatirlar.length > 1) {
      islem = { id: bedelSatirlar[1].key, quantity: 0 };
    } else if (bedelSatirlar[0].quantity !== 1) {
      islem = { id: bedelSatirlar[0].key, quantity: 1 };
    }

    if (!islem) return Promise.resolve(cart);
    degisti = true;
    return cartJson("/cart/change.js", islem).then(function (yeni) { return yeni ? bedelEsitle(yeni, tur + 1) : cart; });
  }

  /* ---------- 2026-09-13: ODEME SEKLI SECICISI (cekmece) ----------
     "Kisiye ozel mi" ve "bedel urunu var mi/fiyati" tag+metafield ister; cart.js bunlari
     GORMEZ. Section Rendering API ile /cart?section_id=rl-cart-ozel'den okunur (sections/
     rl-cart-ozel.liquid -- HTML sarmalayici YOK, govde dogrudan JSON). /cart sayfasi ayni
     karari kendi Liquid'inde SENKRON verdigi icin bu blok SADECE cekmeceyi ilgilendirir.
     Yerlesim: cekmecenin statik "Hemen Satin Al" dugmesinin hemen ustune (rl-header.liquid'e
     hic dokunmadan, DOM'a insertBefore ile). */
  var sonOzelDurum = null;  // {bedelVaryantId, bedelFiyat, bedelVar, ozel}
  var odemeKutu = null;
  var odemeGonderimde = false;

  function odemeSeciciStil() {
    if (document.getElementById("rl-odeme-secim-stil")) return;
    var st = document.createElement("style");
    st.id = "rl-odeme-secim-stil";
    st.textContent =
      ".rl-odeme-secim{margin-top:10px;padding-top:10px;border-top:1px solid var(--rl-line);" +
        "display:grid;gap:8px;min-width:0;max-width:100%}" +
      ".rl-odeme-secim__baslik{margin:0;font-size:12px;font-weight:800;letter-spacing:.04em;color:var(--rl-accent,#d6b25e)}" +
      ".rl-odeme-secim__hapgrup{display:flex;gap:8px;flex-wrap:wrap;min-width:0;max-width:100%}" +
      ".rl-odeme-secim__hap{flex:1 1 auto;min-width:0;padding:8px 12px;border-radius:999px;border:1px solid var(--rl-line);" +
        "background:rgba(255,255,255,.04);color:inherit;font:inherit;font-size:12.5px;font-weight:700;cursor:pointer;" +
        "text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
      ".rl-odeme-secim__hap.is-secili{background:var(--rl-accent,#d6b25e);color:#17120a;border-color:transparent}" +
      ".rl-odeme-secim__hap:disabled{opacity:.5;cursor:wait}" +
      ".rl-odeme-secim__not,.rl-odeme-secim__ozelnot{margin:0;font-size:11px;line-height:1.4;color:var(--rl-muted,#9a9184)}";
    document.head.appendChild(st);
  }

  function odemeSeciciOlustur() {
    if (odemeKutu) return;
    var checkout = document.querySelector(".rl-cartdrawer__checkout");
    if (!checkout || !checkout.parentNode) return;
    odemeSeciciStil();
    odemeKutu = document.createElement("div");
    odemeKutu.className = "rl-odeme-secim";
    odemeKutu.hidden = true;
    // 2026-09-18: ucuncu hap eklendi (Havale/EFT %5 indirim). Kisiye ozel sepette artik
    // TUM kutu degil, yalniz kapida hapi gizleniyor (ozelnot hapgrup'un ustunde kalir).
    odemeKutu.innerHTML =
      '<p class="rl-odeme-secim__ozelnot" data-rl-odeme-ozelnot hidden>Sepetinde kişiye özel ürün olduğu için kapıda ödeme kullanılamaz.</p>' +
      '<p class="rl-odeme-secim__baslik">Ödeme şekli</p>' +
      '<div class="rl-odeme-secim__hapgrup" data-rl-odeme-hapgrup>' +
        '<button type="button" class="rl-odeme-secim__hap" data-rl-odeme-sec="kart">Kart</button>' +
        '<button type="button" class="rl-odeme-secim__hap" data-rl-odeme-sec="havale">Havale/EFT %5 indirim</button>' +
        '<button type="button" class="rl-odeme-secim__hap" data-rl-odeme-sec="kapida">Kapıda ödeme</button>' +
      '</div>' +
      '<p class="rl-odeme-secim__not" data-rl-odeme-not></p>';
    checkout.parentNode.insertBefore(odemeKutu, checkout);
    odemeKutu.querySelector('[data-rl-odeme-sec="kart"]').addEventListener("click", function () { odemeSecimUygula("kart"); });
    odemeKutu.querySelector('[data-rl-odeme-sec="havale"]').addEventListener("click", function () { odemeSecimUygula("havale"); });
    odemeKutu.querySelector('[data-rl-odeme-sec="kapida"]').addEventListener("click", function () { odemeSecimUygula("kapida"); });
  }

  // 2026-09-18: kapida hapi varsa "kapida"; yoksa sonSepet.attributes["Ödeme şekli"] Havale/EFT
  // ise "havale"; yoksa "kart". sonSepet cart.js'in son bilinen gercek hali (attributes dahil).
  function mevcutOdemeSecimi() {
    if (bedelSatirlari(sonSepet)[0]) return "kapida";
    var oznitelikler = (sonSepet && sonSepet.attributes) || {};
    if (oznitelikler["Ödeme şekli"] === "Havale/EFT") return "havale";
    return "kart";
  }

  // 2026-09-19: Kart+Havale HER ZAMAN gorunur (bedel urununden bagimsiz -- PayTR test modundayken
  // Bank Deposit tek gercek odeme yolu). Kapida hapi yalniz bedel urunu VARSA (durum.bedelVaryantId)
  // ve sepet kisiye ozel DEGILSE gosterilir. durum yoksa (section fetch basarisiz/henuz gelmedi)
  // kapida gizlenir, kart/havale secimi yine de mevcutOdemeSecimi() ile sonSepet.attributes'tan calisir.
  function odemeSeciciGuncelle() {
    var durum = sonOzelDurum;
    odemeSeciciOlustur();
    if (!odemeKutu) return;
    odemeKutu.hidden = false;
    var hapgrup = odemeKutu.querySelector("[data-rl-odeme-hapgrup]");
    var notEl = odemeKutu.querySelector("[data-rl-odeme-not]");
    var ozelEl = odemeKutu.querySelector("[data-rl-odeme-ozelnot]");
    var kartBtn = hapgrup.querySelector('[data-rl-odeme-sec="kart"]');
    var havaleBtn = hapgrup.querySelector('[data-rl-odeme-sec="havale"]');
    var kapidaBtn = hapgrup.querySelector('[data-rl-odeme-sec="kapida"]');
    var kapidaGoster = !!(durum && durum.bedelVaryantId && !durum.ozel);
    ozelEl.hidden = !(durum && durum.ozel);
    kapidaBtn.hidden = !kapidaGoster;
    if (kapidaGoster) kapidaBtn.textContent = "Kapıda ödeme +" + durum.bedelFiyat;
    var secim = mevcutOdemeSecimi();
    kartBtn.classList.toggle("is-secili", secim === "kart");
    havaleBtn.classList.toggle("is-secili", secim === "havale");
    kapidaBtn.classList.toggle("is-secili", secim === "kapida");
    if (secim === "havale") {
      notEl.textContent = "Siparişten sonra IBAN bilgisi ekranda ve e-postanda olacak. Açıklamaya sipariş numaranı yazman yeterli.";
    } else if (kapidaGoster) {
      notEl.textContent = "Havale/EFT'de %5 indirim. Kapıda ödemede " + durum.bedelFiyat + " hizmet bedeli eklenir.";
    } else {
      notEl.textContent = "Havale/EFT'de %5 indirim.";
    }
  }

  function odemeSecimUygula(secim) {
    if (odemeGonderimde) return;
    // 2026-09-19: Kart/Havale bedel urununden BAGIMSIZ calisir -- yalniz "kapida" bedel
    // varyantinin var olmasini gerektirir (fee satirini eklemek icin).
    if (secim === "kapida" && (!sonOzelDurum || !sonOzelDurum.bedelVaryantId)) return;
    if (secim === mevcutOdemeSecimi()) return; // zaten secili, istek atma
    odemeGonderimde = true;
    var butonlar = odemeKutu ? Array.prototype.slice.call(odemeKutu.querySelectorAll("button")) : [];
    butonlar.forEach(function (b) { b.disabled = true; });

    function govdeliIstek(yol, govde) {
      return window.fetch(yol, {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(govde)
      }).then(function (r) { if (!r.ok) throw 0; return r.json(); });
    }
    function bedelVarsaKaldir() {
      var mevcutBedel = bedelSatirlari(sonSepet)[0];
      if (!mevcutBedel) return Promise.resolve();
      return govdeliIstek("/cart/change.js", { id: mevcutBedel.key, quantity: 0 });
    }
    function odemeSekliYaz(deger) {
      return govdeliIstek("/cart/update.js", { attributes: { "Ödeme şekli": deger } });
    }

    var istek;
    if (secim === "kapida") {
      istek = govdeliIstek("/cart/add.js", { id: sonOzelDurum.bedelVaryantId, quantity: 1 })
        .then(function () { return odemeSekliYaz(""); });
    } else if (secim === "havale") {
      istek = bedelVarsaKaldir().then(function () { return odemeSekliYaz("Havale/EFT"); });
    } else {
      istek = bedelVarsaKaldir().then(function () { return odemeSekliYaz(""); });
    }
    istek.catch(function () {})
      .then(function () {
        odemeGonderimde = false;
        butonlar.forEach(function (b) { b.disabled = false; });
      });
  }

  // Her gercek sepet guncellemesinde (kaydet()) bir kez cagrilir -- "ozel"/"bedelVar" tazelenir.
  function ozelDurumunuGetir() {
    if (!hamFetch) return;
    hamFetch("/cart?section_id=rl-cart-ozel", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (metin) {
        if (!metin) return;
        // 2026-09-13: Section Rendering API govdeyi HER ZAMAN <div id="shopify-section-...">
        // ile sarar (section dosyasi ne yazarsa yazsin) -- JSON'u ilk { / son } arasindan cikar.
        var basi = metin.indexOf("{"), sonu = metin.lastIndexOf("}");
        if (basi === -1 || sonu === -1 || sonu < basi) return;
        var veri;
        try { veri = JSON.parse(metin.slice(basi, sonu + 1)); } catch (e) { return; }
        sonOzelDurum = {
          bedelVaryantId: (veri && veri.bedelVaryantId) || 0,
          bedelFiyat: (veri && veri.bedelFiyat) || "",
          bedelVar: !!(veri && veri.bedelVar),
          ozel: !!(veri && veri.ozel)
        };
        odemeSeciciGuncelle();
        // Kisiye ozel sepette bedel kalmis olabilir (az once ozele gecti) -- sessizce kaldir.
        if (sonOzelDurum.ozel && sonOzelDurum.bedelVar) {
          var b = bedelSatirlari(sonSepet)[0];
          if (b) {
            window.fetch("/cart/change.js", {
              method: "POST", credentials: "same-origin",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body: JSON.stringify({ id: b.key, quantity: 0 })
            }).catch(function () {});
          }
        }
      })
      .catch(function () {});
  }

  /* ---------- fetch sarmalayici ---------- */
  if (hamFetch) {
    window.fetch = function (girdi, ayar) {
      var url = typeof girdi === "string" ? girdi : (girdi && girdi.url) || "";

      /* Tema zaten /cart.js okuyor (panel acilisi, sepet sayaci). Kendi istegimizi
         atmak yerine AYNI yaniti paylasiyoruz -> panel acilisinda 2 istek yerine 1. */
      if (CART_OKU.test(url)) {
        return hamFetch(girdi, ayar).then(function (resp) {
          if (resp.ok) {
            resp.clone().json()
              .then(function (c) { window.setTimeout(function () { kaydet(c); }, 0); })
              .catch(function () {});
          }
          return resp;
        });
      }

      if (!CART_YOLU.test(url)) return hamFetch(girdi, ayar);

      return hamFetch(girdi, ayar).then(function (resp) {
        if (!resp.ok) return resp;
        // HIZ: her sepet islemine ekstra tur eklemiyoruz.
        //  - /cart/change|update|clear ZATEN tam sepeti donuyor -> yaniti aynen kullan.
        //  - /cart/add.js sadece eklenen satiri donuyor -> yalniz orada sepeti oku.
        //  - Hediye kurallari sepete DOKUNMADIYSA temanin kendi yaniti dogru;
        //    hicbir ek istek yapmadan aynen geri veriyoruz (Doruk: "sepet yavas", 2026-07-29).
        return resp.clone().json()
          .then(function (govde) {
            return (govde && govde.items) ? govde : cartJson("/cart.js");
          })
          .then(function (cart) {
            degisti = false;
            return cart ? esitle(cart) : null;
          })
          .then(function (cart) { return cart ? bedelEsitle(cart) : null; })
          .then(function (son) {
            if (!son || !son.items) return resp;
            // Tema kendi cizimini yapsin; biz hemen ardindan cubugu duzeltiriz.
            window.setTimeout(function () { kaydet(son); }, 0);
            if (!degisti) return resp;   // sepet degismedi -> orijinal yaniti bozma
            return new Response(JSON.stringify(son), {
              status: 200, headers: { "Content-Type": "application/json" }
            });
          })
          .catch(function () { return resp; });
      });
    };
  }

  /* ---------- sayfa yuklenisi + geri tusu (dogrudan /cart girisini de kapsar) ---------- */
  function tazele() {
    if (!hamFetch) return;
    degisti = false;
    cartJson("/cart.js")
      .then(function (cart) { return cart ? esitle(cart) : null; })
      .then(function (cart) { return cart ? bedelEsitle(cart) : null; })
      .then(function (son) {
        if (!son || !son.items) return;
        kaydet(son);
        // /cart sayfasi sunucuda basiliyor: sepeti duzelttiysek eski satirlar ekranda kalir.
        if (degisti && document.body.classList.contains("tpl-cart")) window.location.reload();
      });
  }

  function baslat() { gozlemeBasla(); tazele(); sayfaSecicileri(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", baslat);
  else baslat();
  window.addEventListener("pageshow", function (e) { if (e.persisted) tazele(); });
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && !gonderimde && !Object.keys(bekleyen).length) tazele();
  });

  /* ---------- ADET AKISI ARTIK BIZDE ----------
     Iki olcum bunu zorunlu kildi:
     (a) Tema her tiklamada butonu kilitleyip ~900 ms istek atiyor -> hizli
         art/eksilt "kasiyor" (Doruk, 2026-07-29).
     (b) Ayni anda IKI sepet yazmasi birbirini EZIYOR. Paralel hediye istegi
         denendiginde olcum netti: hediye silindi ama ADET DEGISIMI KAYBOLDU.
         Shopify eszamanli sepet yazmalarini guvenle siralamiyor.
     Cozum: tek yazan biziz. Tiklamalar birikir, 450 ms sessizlikten sonra TEK
     istek gider, hediye esitlemesi ARDINDAN sirayla yapilir. Ekran ise ilk
     tiklamada guncellenir -- bekleme hissedilmez. */
  var bekleyen = {};        // satir anahtari -> gonderilecek adet
  var zamanlayici = null;
  var emniyet = null;
  var gonderimde = false;

  function satirBul(cart, anahtar) {
    var b = null;
    (cart && cart.items || []).forEach(function (it) { if (it.key === anahtar) b = it; });
    return b;
  }

  /* ---------- BOLUNMUS SATIRLARI BIRLESTIR ----------
     OLCUM (2026-07-29): Shopify, Buy X Get Y indirimi bir satirin YALNIZ bir
     kismina tahsis edilince ayni urunu IKI satir olarak donduruyor. Iki satirin
     variant'i ve ozellikleri BIREBIR ayni, sadece key farkli; fark su ki biri
     "1.400 TL uzeri hediye paspas" indirim etiketini tasiyor.
     Musteri bunu "2'den sonra yeni urun eklendi" diye goruyor (Doruk).
     Fiyatlandirma DOGRU, gorunum yanlis. Iki katmanli cozum:
       (a) panelde ayni imzali satirlar tek satirda gosterilir,
       (b) adet degistirildiginde ilk satira TOPLAM yazilir, digerleri 0 olur
           -> bolunme bir sonraki islemde sunucuda da kendiliginden kapanir. */
  function imza(it) { return it.variant_id + "|" + JSON.stringify(it.properties || {}); }

  function gruplar(cart) {
    var g = {};
    (cart && cart.items || []).forEach(function (it) {
      var k = imza(it);
      (g[k] = g[k] || []).push(it);
    });
    return g;
  }

  function satirElemani(anahtar) {
    var b = document.querySelector('[data-key="' + anahtar + '"]');
    return b ? b.closest(".rl-cartdrawer__item") : null;
  }

  /* ---------- TEK SATIR CIZICI ----------
     Onceki surumde iki ayri boyama yolu vardi (tahmini boyama + birlestirme) ve
     birbirinin izini birakiyorlardi: tahmini boyamanin "display:none" yazdigi
     satir bir daha geri gelmiyor, panel sunucudan farkli bir adet gosteriyordu
     (olcum: panel 4, sunucu 5). Artik TEK yol var; gorunurluk, adet ve fiyat
     HER ZAMAN verilen sepetten yeniden turetilir, kalinti kalmaz. */
  function satirlariCiz(cart) {
    var g = gruplar(cart);
    var birincil = {};      // grubun gosterilecek satiri
    var ozet = {};          // anahtar -> {adet, fiyat}
    Object.keys(g).forEach(function (k) {
      var grup = g[k], toplamAdet = 0, toplamFiyat = 0;
      grup.forEach(function (it) { toplamAdet += it.quantity; toplamFiyat += satirTutari(it); });
      birincil[grup[0].key] = 1;
      ozet[grup[0].key] = { adet: toplamAdet, fiyat: toplamFiyat };
    });
    Array.prototype.slice.call(document.querySelectorAll(".rl-cartdrawer__item")).forEach(function (el) {
      if (el.hasAttribute("data-rl-gecici-hediye")) return;      // gecici hediye satiri ayri yonetiliyor
      var k = el.querySelector("[data-key]");
      var anahtar = k && k.getAttribute("data-key");
      var goster = !!(anahtar && birincil[anahtar]);
      var d = goster ? "" : "none";
      if (el.style.display !== d) el.style.display = d;
      if (!goster) return;
      var o = ozet[anahtar];
      var btn = el.querySelector("[data-cart-qty], [data-cart-custom-qty]");
      var birim = Math.max(1, parseInt(btn && btn.getAttribute("data-unit"), 10) || 1);
      var sayi = el.querySelector(".rl-cartdrawer__qty span");
      var sd = String(Math.max(1, Math.round(o.adet / birim)));
      if (sayi && sayi.textContent !== sd) sayi.textContent = sd;
      var fe = el.querySelector(".rl-cartdrawer__price");
      var fd = money(o.fiyat);
      if (fe && fe.textContent !== fd) fe.textContent = fd;
    });
    var toplam = document.querySelector("[data-cart-drawer-total]");
    var td = money(cart.total_price || 0);
    if (toplam && toplam.textContent !== td) toplam.textContent = td;
  }

  function geciciHediyeSatiri(ekle) {
    var govde = document.querySelector("[data-cart-drawer-items]");
    if (!govde) return;
    var mevcut = govde.querySelector("[data-rl-gecici-hediye]");
    if (!ekle) { if (mevcut) mevcut.remove(); return; }
    if (mevcut || govde.querySelector(".rl-gift-line")) return;
    stilEkle();
    var a = document.createElement("article");
    a.className = "rl-cartdrawer__item rl-gift-line";
    a.setAttribute("data-rl-gecici-hediye", "");
    a.innerHTML =
      '<span class="rl-cartdrawer__media"><span class="rl-cartdrawer__ph"></span></span>' +
      '<div class="rl-cartdrawer__info">' +
        '<span class="rl-cartdrawer__title">Hediye Paspas</span>' +
        '<div class="rl-cartdrawer__meta"><span>40x60 cm</span></div>' +
        '<span class="rl-gift-rozet">Hediyen &#127873;</span>' +
      '</div>' +
      '<span class="rl-cartdrawer__price">0,00 TL</span>';
    govde.insertBefore(a, govde.firstChild);
  }

  function tahminiSepet() {
    var vid = giftVaryant();
    var kopya = JSON.parse(JSON.stringify(sonSepet));
    Object.keys(bekleyen).forEach(function (k) {
      var s = satirBul(kopya, k);
      if (!s) return;
      var birimFiyat = s.final_line_price / Math.max(1, s.quantity);
      s.quantity = bekleyen[k];
      s.final_line_price = birimFiyat * bekleyen[k];
    });
    kopya.items = kopya.items.filter(function (it) { return it.quantity > 0; });
    /* Esigin ALTINA dusuluyorsa hediye satirini tahminde de dus: yoksa cubuk
       "320 TL kaldi" derken satir ekranda kalip ~1 sn celiski yaratiyordu. */
    if (vid && !(gercekUrunVarMi(kopya) && esikTutari(kopya) >= GIFT_ESIK)) {
      kopya.items = kopya.items.filter(function (it) { return it.variant_id !== vid; });
    }
    kopya.total_price = kopya.items.reduce(function (t, it) {
      return t + (vid && it.variant_id === vid ? 0 : it.final_line_price);
    }, 0);
    return kopya;
  }

  /* Tahmini boyama da AYNI cizicidan gecer: kendi DOM yazimi yok. */
  function ekraniBoya(kopya) {
    ciz(kopya);
    satiriKilitle(kopya);
    bedelSatiriKilitle(kopya);
    satirlariCiz(kopya);
    if (giftVaryant()) {
      var hakEdildi = gercekUrunVarMi(kopya) && esikTutari(kopya) >= GIFT_ESIK;
      geciciHediyeSatiri(hakEdildi && !hediyeSatirlari(kopya).length);
    }
  }

  function gonder() {
    if (gonderimde || !Object.keys(bekleyen).length) return;
    gonderimde = true;
    var isler = Object.keys(bekleyen).map(function (k) { return { id: k, quantity: bekleyen[k] }; });
    bekleyen = {};
    var zincir = Promise.resolve(null);
    isler.forEach(function (is) {                       // SIRAYLA: eszamanli yazma yok
      zincir = zincir.then(function () { return cartJson("/cart/change.js", is); });
    });
    zincir
      .then(function (c) { return c && c.items ? c : cartJson("/cart.js"); })
      .then(function (c) { return c ? esitle(c) : null; })
      .then(function () {
        gonderimde = false;
        if (emniyet) { window.clearTimeout(emniyet); emniyet = null; }
        /* Kapanis okumasini KENDIMIZ yapmiyoruz: RugLabCart.open() zaten /cart.js
           cekip drawer'i yeniden ciziyor, o istegi sarmalayici yakalayip ekrani
           gercek veriyle boyuyor. Ayrica cart.js atmak bosuna bir tur olurdu. */
        if (window.RugLabCart && window.RugLabCart.open) window.RugLabCart.open();
        else cartJson("/cart.js").then(kaydet);
        if (Object.keys(bekleyen).length) gonder();     // arada yeni tiklama olduysa devam
      })
      .catch(function () {
        /* KURTARMA: istek basarisiz olursa bekleyen tahmin takili kalir ve panel
           yanlis degerde DONAR (olcum: panel 4, sunucu 7). Temizleyip gercek
           sepetle yeniden ciziyoruz — kullanici bozuk ekranla kalmasin. */
        gonderimde = false; bekleyen = {}; tazele();
      });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cart-qty], [data-cart-custom-qty]");
    if (!btn || !sonSepet || !sonSepet.items) return;
    e.preventDefault();
    e.stopPropagation();                 // temanin istegi gitmesin; tek yazan biziz

    var anahtar = btn.getAttribute("data-key");
    var birim = Math.max(1, parseInt(btn.getAttribute("data-unit"), 10) || 1);
    var yon = /azalt/i.test(btn.getAttribute("aria-label") || "") ? -1 : 1;
    var satir = satirBul(sonSepet, anahtar);
    if (!satir) return;
    /* data-q OKUNMAZ: tema yeniden cizmedigi surece bayat kalir ve ust uste
       tiklamada hep ayni hedefi verir. Yon + mevcut tahminden hesapliyoruz.
       Satir bolunmusse GRUBUN TOPLAMI uzerinden calisir; toplam ilk satira
       yazilir, digerleri sifirlanir -> bolunme sunucuda da kapanir. */
    var grup = gruplar(sonSepet)[imza(satir)] || [satir];
    var grupToplam = 0;
    grup.forEach(function (it) {
      grupToplam += (bekleyen[it.key] !== undefined ? bekleyen[it.key] : it.quantity);
    });
    var yeniToplam = Math.max(0, grupToplam + yon * birim);
    grup.forEach(function (it, i) { bekleyen[it.key] = (i === 0 ? yeniToplam : 0); });
    anahtar = grup[0].key;

    ekraniBoya(tahminiSepet());
    if (zamanlayici) window.clearTimeout(zamanlayici);
    zamanlayici = window.setTimeout(gonder, 450);
    /* EMNIYET: herhangi bir sebeple gonderim gerceklesmez ya da yarida kalirsa
       (sekme uyumasi, ag kesintisi, sayfa donmasi) panel tahmini degerde asili
       kalmasin. 6 sn sonra hala bekleyen varsa zorla gercek sepete donuyoruz. */
    if (emniyet) window.clearTimeout(emniyet);
    emniyet = window.setTimeout(function () {
      if (Object.keys(bekleyen).length && !gonderimde) { bekleyen = {}; tazele(); }
    }, 6000);
  }, true);

})();
